export var SUCCESS_MESSAGE = 'Event tracked successfully';
export var UNEXPECTED_ERROR_MESSAGE = 'Unexpected error occurred';
export var MAX_RETRIES_EXCEEDED_MESSAGE = 'Event rejected due to exceeded retry count';
export var OPT_OUT_MESSAGE = 'Event skipped due to optOut config';
export var MISSING_API_KEY_MESSAGE = 'Event rejected due to missing API key';
export var INVALID_API_KEY = 'Invalid API key';
export var CLIENT_NOT_INITIALIZED = 'Client not initialized';
//# sourceMappingURL=messages.js.map